<template>
    <div id="semester">
        <!-- Semester Title -->
        <h1 @click="expand = !expand">
            <i class="fas fa-caret-down" v-if="expand"></i>
            <i class="fas fa-caret-right" v-else></i>
            {{academicRecords.title}}
        </h1>
        <!-- Semestor Academic Records -->
        <div v-show="expand">
            <AcademicTable :list="academics"/>
            <!-- sourses table -->
            <table>
                <thead>
                    <tr>
                        <td>Course</td>
                        <td>Course Name</td>
                        <td>Units</td>
                        <td>Grade</td>
                        <td>Grade Points</td>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(c, index) in academicRecords.enrollments" :key="index">
                        <td v-for="(e, e_index) in c" :key="e_index">{{e}}</td>
                    </tr>
                </tbody>
                <tfoot>
                    <tr>
                        <td></td>
                        <td></td>
                        <td>{{totalUnits}}</td>
                        <td></td>
                        <td>{{totalGradePoints.toFixed(3)}}</td>
                    </tr>
                </tfoot>
            </table>
        </div>
    </div>
</template>

<script>
import AcademicTable from './AcademicTable.vue'

export default {
    name:'Semester',
    components: { AcademicTable },
    props: ['academicRecords'],
    data() {
        return {
            expand: false,      // the list is expanded or not
            academics: {},           // information for AcademicTable
            totalUnits: 0,
            totalGradePoints: 0,
        }
    },
    mounted(){
        // Compute the totalUnits and totalGradePoints
        this.academicRecords.enrollments.forEach(e => {
            this.totalUnits += e.units
            this.totalGradePoints += e.gradePoints
        })
        // Pack the requires information
        this.academics = {
            element: [
                ['Units Earned', this.totalUnits],
                ['Term GPA', this.academicRecords.termGPA.toFixed(3)],
                ['Cumulative GPA', (this.academicRecords.totalGradePoints / this.academicRecords.totalUnits).toFixed(3)],
                ['Academic Standing', 'Good Standing'],
            ]
        }
    }
}
</script>

<style scoped>
/* section title */
h1{
    height: 25px;
    font-size: 20px;
    margin-bottom: 25px;
    font-weight: bold;
    text-align: left;
    border-bottom: 1px solid #CCC;
    cursor: pointer;
}
h1 i{
    width: 12px;
}


/* courses table */
table{
    width: 800px;
    margin: 50px;
    border: 2px solid black;
    margin: 25px auto;
    border-collapse: collapse;
}
table td{
    border: 1px solid black;
    border-right: 2px solid black;
    height: 40px;
    vertical-align: middle;
    text-align: center;
}
table td:nth-child(2){
    width: 350px;
}
table thead td,
table tfoot td{
    border: 2px solid black;
    background-color: rgb(189, 187, 187);
    font-weight: bolder;
}
table tbody tr:nth-child(odd){
    background-color: #fff;
}
table tbody tr:nth-child(even){
    background-color: rgb(216, 214, 214);
}
</style>